
import React from "react";
import { Link } from "react-router-dom";
import { FinalizeRegistrationForm } from "@/components/auth/FinalizeRegistrationForm";
import { LeftPanel } from "@/components/auth/FinalizeRegistrationForm/LeftPanel";
import { useCommunity } from "@/contexts/CommunityContext";
import { motion } from "framer-motion";
import { CommunityAccessCheck } from "@/components/CommunityAccessCheck";
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { Card, CardContent } from "@/components/ui/card";
import { House } from 'lucide-react';

const FinalizeRegistrationInner = () => {
  const { currentCommunity } = useCommunity();
  const communityName = currentCommunity?.name ?? "your community";
  
  // Set page title directly
  useDocumentTitle(`Complete Registration - ${communityName}`);

  return (
    <div className="flex min-h-screen relative">
      {/* Home Navigation Link */}
      <Link
        to="/"
        className="absolute top-6 left-6 z-50 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background/80 backdrop-blur-sm border border-border/50 hover:bg-background hover:border-border transition-all duration-200 shadow-sm hover:shadow-md"
        aria-label="Go to home page"
      >
        <House className="h-4 w-4 text-muted-foreground hover:text-foreground transition-colors" />
        <span className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Home</span>
      </Link>

      {/* Left Panel with branded background - matching Auth page proportions (42%) */}
      <div className="hidden md:flex md:w-[42%] bg-[hsl(var(--primary)/0.03)] relative overflow-hidden">
        {/* Decorative Elements - matching Auth page */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-20 w-32 h-32 bg-primary/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-40 right-20 w-48 h-48 bg-primary/8 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-10 w-24 h-24 bg-primary/6 rounded-full blur-2xl"></div>
        </div>
        
        {/* Content - matching Auth page structure */}
        <div className="relative z-10 flex flex-col justify-center px-12 py-16">
          <LeftPanel communityName={communityName} />
        </div>
      </div>

      {/* Right Panel - Form (58% to match Auth page) */}
      <motion.div 
        className="w-full md:w-[58%] flex items-center justify-center px-4 py-8 lg:px-8 overflow-y-auto bg-background"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="w-full max-w-3xl">
          <Card className="shadow-lg border-0">
            <CardContent className="p-8 lg:p-12">
              <FinalizeRegistrationForm />
            </CardContent>
          </Card>
        </div>
      </motion.div>
    </div>
  );
};

const FinalizeRegistration = () => {
  return (
    <CommunityAccessCheck>
      <FinalizeRegistrationInner />
    </CommunityAccessCheck>
  );
};

export default FinalizeRegistration;
